<template>
  <a-modal
    v-model="visible"
    title="Edit Discipline Category"
  >
    <template slot="footer">
      <a-button @click="handleCancel">Cancel</a-button>
      <a-button type="primary" :loading="loading" @click="handleSubmit">
        Edit Category
      </a-button>
    </template>

    <a-form :form="form">
      <a-form-item label="Name">
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: 'Please enter name' }] },
          ]"
        />
      </a-form-item>

      <a-form-item label="Description">
        <a-input v-decorator="['description']" />
      </a-form-item>

      <a-form-item label="Active">
        <a-checkbox v-decorator="['active', { valuePropName: 'checked' }]">
          Active
        </a-checkbox>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'EditCategory',
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      editId: null,
    }
  },
  mounted() {
    this.$eventBus.$on('openCategoryEditModal', this.loadCategory)
  },
  beforeDestroy() {
    this.$eventBus.$off('openCategoryEditModal', this.loadCategory)
  },
  methods: {
    loadCategory(id) {
      this.editId = id
      this.visible = true
      this.loading = true
      this.$http
        .get(`/api/student-discipline-category/${id}`)
        .then(({ data }) => {
          const category = data.data
          this.form.setFieldsValue({
            name: category.name,
            description: category.description,
            active: category.active === 1,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .put(`/api/student-discipline-category/${this.editId}`, {
              name: values.name,
              description: values.description,
              active: values.active ? 1 : 0,
            })
            .then(() => {
              this.visible = false
              this.$emit('edited')
              this.$notification.success({
                message: 'Category Updated',
                description: `${values.name} updated successfully.`,
              })
            })
            .catch((error) => {
              this.$neoNotify.error(error)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.loading = false
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
